/**首页 头部路由表 */
export const homeNavBarRoute = [
  { id: "0", name: "首页", path: "/" },
  { id: "13", name: "美妆日化", path: "/ClinicZone" },
  { id: "14", name: "养生保健", path: "/ApparatusZone" },
  { id: "15", name: "医疗器械", path: "/ChineseMedicineZone" },
  { id: "17", name: "中药医馆", path: "/PublicZone" },
  { id: "20", name: "今日特价", path: "/DailyZone" },
  { id: "21", name: "品牌折扣", path: "/Promotion" },
  { id: "22", name: "积分商城", path: "/PointsMall" },
  { id: "25", name: "品牌专区", path: "/BrandZone" },
  { id: "27", name: "精品药品", path: "/GoodsList" },
  { id: "30", name: "新品优选", path: "/newGoods" },
  { id: "18", name: "单品包邮", path: "/sigMail" },
  { id: "31", name: "清仓专区", path: "/ClearZoom" },
];
export const defaultAanufacturerTags = [
  { level: 4, id: "A", name: "A" },
  { level: 4, id: "B", name: "B" },
  { level: 4, id: "C", name: "C" },
  { level: 4, id: "D", name: "D" },
  { level: 4, id: "E", name: "E" },
  { level: 4, id: "F", name: "F" },
  { level: 4, id: "G", name: "G" },
  { level: 4, id: "H", name: "H" },
  { level: 4, id: "I", name: "I" },
  { level: 4, id: "J", name: "J" },
  { level: 4, id: "K", name: "K" },
  { level: 4, id: "L", name: "L" },
  { level: 4, id: "M", name: "M" },
  { level: 4, id: "N", name: "N" },
  { level: 4, id: "O", name: "O" },
  { level: 4, id: "P", name: "P" },
  { level: 4, id: "Q", name: "Q" },
  { level: 4, id: "R", name: "R" },
  { level: 4, id: "S", name: "S" },
  { level: 4, id: "T", name: "T" },
  { level: 4, id: "U", name: "U" },
  { level: 4, id: "V", name: "V" },
  { level: 4, id: "W", name: "W" },
  { level: 4, id: "X", name: "X" },
  { level: 4, id: "Y", name: "Y" },
  { level: 4, id: "Z", name: "Z" }
];
// 商品标签
export const defaultGoodsLabelSet = {
  0: "普药",
  1: "特价",
  2: "买赠",
  3: "换购",
  4: "效期",
  5: "阶梯",
  6: "精品",
  7: "新特",
  8: "秒杀",
  9: "包邮",
  10: "套餐"
};



// WEBPACK FOOTER //
// ./src/components/nav/staticData.js